import { ActionIcon, Tooltip } from '@mantine/core';
import { IconHelpCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

/** A separate help control so looking up an action never triggers that action. */
export const HelpHint = ({ subject, label }: { subject: string; label: string }) => {
    const { t } = useTranslation();

    return (
        <Tooltip
            label={label}
            multiline
            maw={340}
            withArrow
            events={{ hover: true, focus: true, touch: true }}
        >
            <ActionIcon
                variant='subtle'
                color='gray'
                size='xs'
                aria-label={t('components.helpHint', { subject })}
                onMouseDown={(event) => event.stopPropagation()}
                onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
            >
                <IconHelpCircle size={16} aria-hidden />
            </ActionIcon>
        </Tooltip>
    );
};

/** Menu items are buttons themselves: use a non-button icon inside them. */
export const MenuHelpIcon = () => (
    <span
        aria-hidden='true'
        style={{ display: 'flex', cursor: 'help' }}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
        }}
    >
        <IconHelpCircle size={16} />
    </span>
);
